var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"hamburger-icon",class:{ active: _vm.active }},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }